import _DevelopmentOpportunityService from "../services/development-opportunity-service";
import { IDevelopmentOpportunityGuestService } from "../types/services/development-opportunity-guest-service";
import { IDevelopmentOpportunityService } from "../types/services/development-opportunity-service";

const instance = new _DevelopmentOpportunityService();

export const DevelopmentOpportunityService: IDevelopmentOpportunityService = instance;

export const DevelopmentOpportunityGuestService: IDevelopmentOpportunityGuestService = instance;
